import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import seedrandom from "seedrandom";

const rng = seedrandom('vivrepistoutecaounon');

export class AdditionalFloatingStars {

  constructor(el) {
    this.$el = $(el);

    this.rng = seedrandom('fautdesetoiles');

    this.init();
  }

  init() {
    this.$stars = this.$el.find(".additional-floating-star");

    // Place draggable randomly in space
    this.randomizeInitialPosition();

    // Create animation timeline
    this.tl = this.createRepeatableTimeline();
  }

  createRepeatableTimeline() {

    const tl = gsap.timeline();

    const baseAnim = {
      yoyo: true,
      repeat: -1,
      ease: "sine.inOut"
    }

    this.$el.find(".additional-floating-star").each((i, n) => {
      const $star = $(n);

      tl.to($star, {
        y: map(rng(), 0, 1, 5, 15) * (rng() > 0.5 ? 1 : -1),
        duration: map(rng(), 0, 1, 2, 4),
        ...baseAnim
      }, 0);

      tl.to($star, {
        scale: "-=" + map(rng(), 0, 1, 0.1, 0.4),
        duration: map(rng(), 0, 1, 2, 6),
        ...baseAnim
      }, 0);
    })

    return tl;
  }

  stop() {
    this.tl.pause();
  }

  start() {
    this.tl.play();
  }

  randomizeInitialPosition() {
    const width = 200;
    const height = 300;

    const itemsLocations = [
      {x: 388, y: 160},
      {x: 680, y: 160},
      {x: 968, y: 160},
      {x: 1253, y: 160},
      {x: 1550, y: 160},
    ];

    this.$stars.each((i, n) => {
      const itemsMod = i % itemsLocations.length;
      const r1 = this.rng();
      const r2 = map(this.rng(), 0, 1, 0.1, 1); // Set to 1 to get a better understanding
      gsap.set(n, {
        left: r1 * (width) + itemsLocations[itemsMod].x - (width / 2),
        top: r2 * (height) + itemsLocations[itemsMod].y - (height / 2),
        scale: map(rng(), 0, 1, 0.2, 1)
      });
    })
  }

}

